import React from 'react';
import { Table } from '@bynder/design-system';
import useAccessRights from 'packages/hooks/useAccessRights';
import { getCollectionSharingIcon } from 'packages/pages/components/card/utils';
import CategoryThumbnail from 'packages/pages/categoryDetails/components/CategoryThumbnail';
import { Category } from 'packages/store/categories/types';
import { Box } from './TitleCell.styled';
import { AllowedIndicatorTypes } from 'packages/pages/components/templates/types';

const CategoryTitleCell = ({
    category,
    allowedIndicatorTypes,
}: {
    category: Category;
    allowedIndicatorTypes?: Omit<AllowedIndicatorTypes, 'folder'> & { folder?: false };
}) => {
    const { getIdentityRole, getIdentityRoleAllUsers } = useAccessRights();

    return (
        <Table.Cell thumbnail={<CategoryThumbnail category={category} />}>
            <Box style={{ position: 'relative' }}>
                <div>{category.name}</div>
                <div>
                    {allowedIndicatorTypes?.sharing &&
                        getCollectionSharingIcon(category, { getIdentityRole, getIdentityRoleAllUsers })}
                </div>
            </Box>
        </Table.Cell>
    );
};

export default CategoryTitleCell;
